// extracted by mini-css-extract-plugin
export default {"article":"Info_article__-F7Wt","link":"Info_link__JKE90","tabContainer":"Info_tabContainer__T+Zsc","articles":"Info_articles__x4ge3"};